<ion-item-sliding #slidingItem>
  <ion-item lines="none" (click)="cardClick.emit()">
    <terra-notification-card [unread]="!notification.markedReadAt">
      <terra-avatar
        [src]="notification.createdByUserAvatarUrl"
        [initials]="notification.createdByUserName | slice: 0 : 1" />

      <terra-notification-card-title [innerHTML]="notification | notificationTitle: language | terraHtmlSanitizer" />

      <terra-notification-card-suffix>
        {{ notification.createdAt | timeAgo }}
      </terra-notification-card-suffix>

      <terra-description>
        {{ notification.teamName }} | {{ notification.itemType | itemsName: language }}
      </terra-description>
    </terra-notification-card>
  </ion-item>

  <!-- Swipe right → Mark read (unread notifications) -->
  @if (!notification.markedReadAt) {
    <ion-item-options side="start">
      <ion-item-option class="swipe-option" (click)="onToggleReadStatus()">
        <div class="swipe-option__inner">
          <ion-icon src="assets/icons/circle--regular.svg" />
          Mark read
        </div>
      </ion-item-option>
    </ion-item-options>
  }

  <!-- Swipe left → Mark unread (read notifications) -->
  @if (notification.markedReadAt) {
    <ion-item-options side="end">
      <ion-item-option class="swipe-option" (click)="onToggleReadStatus()">
        <div class="swipe-option__inner">
          <ion-icon src="assets/icons/circle--regular.svg" />
          Mark unread
        </div>
      </ion-item-option>
    </ion-item-options>
  }
</ion-item-sliding>
